import PictureList from './picture-list.vue'
import VideoList from './video-list.vue'
const PreviewFile = {
  props: {
    data: {
      type: Object
    },
    index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    showPicture() {
      return this.data.photos && this.data.photos.length > 0
    },
    showVideo() {
      return this.data.videos && this.data.videos.length > 0
    }
  },
  components: {
    PictureList,
    VideoList
  }
}
export default PreviewFile